"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPunchWorkflowEligible = exports.getHoursAndMinutes = exports.getMinutes = exports.getHours = exports.getPayCodeLocalization = exports.bytesToSize = void 0;
const atozBaseUrl = {
    prod: 'https://atoz.amazon.work',
    beta: 'https://atoz.integ.amazon.com',
    dev: 'https://atoz.integ.amazon.com'
};
const bytesToSize = (bytes, decimals = 2) => {
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0)
        return '0 Bytes';
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${parseFloat((bytes / Math.pow(1024, i)).toFixed(dm))} ${sizes[i]}`;
};
exports.bytesToSize = bytesToSize;
const getPayCodeLocalization = (key, t) => {
    if (!key || key.length === 0) {
        return key;
    }
    return t(key, { keySeparator: '|' });
};
exports.getPayCodeLocalization = getPayCodeLocalization;
const getHours = (seconds) => {
    return Math.floor(seconds / 3600);
};
exports.getHours = getHours;
const getMinutes = (seconds) => {
    return Math.floor((seconds % 3600) / 60);
};
exports.getMinutes = getMinutes;
const getHoursAndMinutes = (seconds) => {
    const hours = (0, exports.getHours)(seconds);
    const minutes = (0, exports.getMinutes)(seconds);
    if (hours > 0) {
        return `${hours}h ago`;
    }
    return `${minutes}m ago`;
};
exports.getHoursAndMinutes = getHoursAndMinutes;
const isPunchWorkflowEligible = (punchWFFeatureGates, isWeb) => {
    const { isSubmitMissedPunchEnabled, isDeleteDupePunchEnabled, isDeleteMpcaMpcsForWebEnabled, isDeleteMpcaMpcsForNativeEnabled, isPunchEditForWebEnabled, isPunchEditForNativeEnabled } = punchWFFeatureGates;
    return (isSubmitMissedPunchEnabled ||
        isDeleteDupePunchEnabled ||
        (isWeb && (isDeleteMpcaMpcsForWebEnabled || isPunchEditForWebEnabled)) ||
        (!isWeb &&
            (isDeleteMpcaMpcsForNativeEnabled || isPunchEditForNativeEnabled)));
};
exports.isPunchWorkflowEligible = isPunchWorkflowEligible;
